import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { signInWithEmailAndPassword } from 'firebase/auth';

import { auth } from '../firebase_config';

import * as yup from 'yup';

import { toast } from 'react-toastify';

export const LoginForm = ({ setShowRegister }) => {
  const [passError, setPassError] = useState(null);
  const schema = yup
    .object({
      email: yup.string().required('email is a required field').email('email is not valid'),
      password: yup.string().required('password is a required field').min(6, 'password must be at least 6 characters'),
    })
    .required();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleSignIn = (data) => {
    signInWithEmailAndPassword(auth, data.email, data.password)
      .then((cred) => {
        reset();
        toast.success('Welcome back', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      })
      .catch((err) => {
        console.log(err.message);
        setPassError('wrong password');
      });
  };

  return (
    <div className="min-w-320 min-h-260 bg-shadow border-2 border-transparent rounded-lg px-3 py-0 md:py-2.5 relative">
      <form onSubmit={handleSubmit(handleSignIn)}>
        <div className="my-2">
          <label htmlFor="email" className="h-11 w-78 bg-transparent font-poppins font-normal text-lg text-background">
            Enter your email
          </label>
          <br />
          <div className="flex flex-col">
            <input
              type="email"
              id="email"
              placeholder="Type here"
              className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
              {...register('email', { required: true })}
            />
            <span className="px-4 text-like">{errors.email?.message}</span>
          </div>
        </div>
        <div className="my-2">
          <label
            htmlFor="password"
            className="h-11 w-78 bg-transparent font-poppins font-normal text-lg text-background">
            Enter your password
          </label>
          <br />
          <div className="flex flex-col">
            <input
              type="password"
              id="password"
              placeholder="Password"
              className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
              {...register('password', { required: true })}
            />
            <span className="px-4 text-like">{passError ? passError : errors.password?.message}</span>
          </div>
        </div>
        <button
          type="submit"
          className="my-4 p-1 rounded-full h-10 w-28 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border border-transparent text-font hover:bg-none duration-300 hover:border-borderColor hover:text-borderColor">
          Login
        </button>
        <span className="font-poppins text-background mb-1 text-sm font-medium leading-3 text-center">
          Don&#8217;t have an account?&nbsp;
        </span>
        <button
          className="font-poppins text-borderColor mb-1 text-sm font-medium leading-3 hover:text-background duration-300 after:content-[''] after:invisible after:absolute after:bottom-2 after:left-44 after:w-0 after:border after:border-borderColor after:duration-300 hover:after:visible hover:after:w-24"
          onClick={() => setShowRegister(true)}>
          Sign up now
        </button>
      </form>
    </div>
  );
};
